var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgErrorTriangle = function SvgErrorTriangle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#E7896F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4528 48.0001H47.5528C50.1195 48.0001 51.7195 45.2168 50.4361 43.0001L37.8861 21.3168C36.6028 19.1001 33.4028 19.1001 32.1195 21.3168L19.5695 43.0001C18.2861 45.2168 19.8861 48.0001 22.4528 48.0001ZM35.0028 36.3335C34.0861 36.3335 33.3361 35.5835 33.3361 34.6668V31.3335C33.3361 30.4168 34.0861 29.6668 35.0028 29.6668C35.9195 29.6668 36.6695 30.4168 36.6695 31.3335V34.6668C36.6695 35.5835 35.9195 36.3335 35.0028 36.3335ZM36.6695 43.0001H33.3361V39.6668H36.6695V43.0001Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/errorTriangle.74011bf6.svg";
export { ForwardRef as ReactComponent };